import type { Table } from '@tanstack/react-table'
import { X } from 'lucide-react'

import { Button } from '@klear/ui/components/button'
import { Input } from '@klear/ui/components/input'

import { DataTableFacetedFilter } from '@klear/ui/components/data-table-faceted-filter'
import type { DataTableFilter } from '@klear/ui/components/data-table'

interface DataTableToolbarProps<TData> {
  table: Table<TData>
  filters: DataTableFilter[]
}

export function DataTableToolbar<TData>({ table, filters }: DataTableToolbarProps<TData>) {
  const isFiltered = table.getState().columnFilters.length > 0

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder="Filter all columns..."
          value={table.getState().globalFilter ?? ''}
          onChange={(event) => table.setGlobalFilter((event.target as HTMLInputElement).value)}
          className="h-8 w-[150px] lg:w-[250px]"
        />
        {filters.map((filter) => (
          <DataTableFacetedFilter
            key={filter.column}
            column={table.getColumn(filter.column)}
            title={filter.title}
            options={filter.options}
          />
        ))}
        {isFiltered && (
          <Button variant="ghost" onClick={() => table.resetColumnFilters()} className="h-8 px-2 lg:px-3">
            Reset
            <X />
          </Button>
        )}
      </div>
    </div>
  )
}
